import { colors, fonts, fontSizes } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .notification-menu-item {
    height: 3.75rem;
    min-width: 13rem;
    font: ${fonts.regular};
    font-size: ${fontSizes.tiny};
    color: ${colors.text};
    border: solid 1px ${colors.border};
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    cursor: pointer;
  }

  .even { background-color: ${colors.lighterGray}; }

  .notification-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    margin-left: 0.5rem;
  }


  .notification-title {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.tiny};
    clor: ${colors.text};
  }

  .notification-date {
    font: ${fonts.regular};
    font-size: ${fontSizes.micro};
    color: ${colors.lightText};
  }
`
